import { forwardRef, ForwardRefExoticComponent, PropsWithChildren, RefAttributes } from 'react'
import { Box, BoxProps } from '@mui/material'

type Props = BoxProps & {
  className?: string
}

export const Fullbleed: ForwardRefExoticComponent<
  Omit<PropsWithChildren<Props>, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, PropsWithChildren<Props>>((props, ref) => <Box m={-2} ref={ref} {...props} />)
